import * as React from 'react';

function SvgArrowForward(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.188 3.217a.74.74 0 011.048 0l8.547 8.547a.74.74 0 010 1.048l-8.547 8.546a.74.74 0 11-1.048-1.047l7.283-7.283H2.741a.74.74 0 010-1.481h16.73l-7.283-7.282a.74.74 0 010-1.048z", clipRule: "evenodd" })));
}

export default SvgArrowForward;
